export const CAMPAIGN_STATUS = {
  DRAFT: 1,
  OPEN: 2,
  CLOSED: 3,
}
